module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./AlipaySchemeView.js"));
	}, "AlipayScheme");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AlipayScheme!./src/pages/Shop/PayMent/AlipayScheme/AlipaySchemeView.js
// module id = 902
// module chunks = 431